<template>
  <div
    v-if="isVisible"
    class="retail-tech-show-banner"
  >
    <div class="retail-tech-show-content">
      <div class="retail-tech-show-brand-section">
        <img
          class="reelables-logo"
          :src="logo"
          :height="40"
          alt="Reelables logo"
        >
        <img
          src="https://cdn.asp.events/CLIENT_Nineteen_F7A1E73F_5056_B725_6BE81DEAAC036B43/sites/retail-technology-show-20/media/2026/2026-logos/RTS-2026-Landscape-V2-on-Black-.png/fit-in/600x1200/filters:no_upscale()"
          alt="Retail Tech Show 2026 Logo"
          class="retail-tech-show-logo"
        >
        <div class="retail-tech-show-text">
          <p>
            <strong>Find us at</strong>
          </p>
          <p
            v-if="boothNumber"
            class="booth-text"
          >
            {{ boothNumber }}
          </p>
        </div>
      </div>

      <div class="retail-tech-show-actions">
        <p class="find-us-text">
          <strong>Find us at</strong>
        </p>
        <span
          v-if="boothNumber"
          class="booth-badge"
        >{{ boothNumber }}</span>
        <button
          v-if="hasButton"
          class="banner-button"
          @click="clickButton"
        >
          {{ buttonText }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import LogoImage from '../../../assets/images/reelables-r-logo-white.svg';

export default {
  name: 'RetailTechShow2026Banner',
  props: {
    boothNumber: {
      type: String,
      default: '',
    },
    buttonText: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isVisible: true,
    };
  },
  computed: {
    logo() {
      return LogoImage;
    },
    hasButton() {
      return !!this.buttonText;
    },
  },
  methods: {
    clickButton() {
      this.$emit('button-click');
    },
  },
};
</script>

<style scoped lang="scss">
.retail-tech-show-banner {
  position: absolute;
  top: 0;
  background: linear-gradient(90deg, #000 0%, #4E2056 100%);
  color: #ffffff;
  padding: 8px;
  border-bottom: 3px solid #8C4B9D;
  font-family: Arial, sans-serif;
  width: 100%;
  z-index: 10;
}

.retail-tech-show-content {
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.retail-tech-show-brand-section {
  display: flex;
  align-items: center;
  gap: 20px;
}

.retail-tech-show-logo {
  height: 35px; /* Adjust height as needed */
  width: auto;
  margin-left: -8px;
}

.reelables-logo {
  margin-left: -8px;
}

.retail-tech-show-text p {
  margin: 0;
  font-size: 14px;
}

.details {
  display: block;
  font-size: 12px;
  color: #cbd5e0;
}

.retail-tech-show-actions {
  display: flex;
  align-items: center;
  gap: 15px;
}

.retail-tech-show-text{
  display: none;
}

.booth-badge {
  background-color: lighten(#8C4B9D, 20%);
  color: #000;
  padding: 3px 8px;
  font-weight: bold;
  font-size: 14px;
  border-radius: 2px;
}

.banner-button {
  background-color: #ffffff;
  color: #002e5d;
  padding: 6px 14px;
  text-decoration: none;
  font-weight: bold;
  font-size: 13px;
  border-radius: 4px;
  transition: 0.2s ease-in-out;
}

.banner-button:hover {
  background-color: #d4af37;
  color: #ffffff;
}

/* Mobile Responsiveness */
@media (max-width: 768px) {
  .retail-tech-show-logo {
    height: 25px;
  }
  .details {
    display: inline;
    margin-left: 5px;
  }
  .retail-tech-show-text p {
    font-size: 12px;
  }
  .retail-tech-show-text {
    display: block;
  }
  .booth-badge, .find-us-text {
    display: none; /* Hide booth on small mobile to save space */
  }
}
</style>
